import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['vatNumberContainer']

  toggleVatNumberInput (e) {
    this.vatNumberContainerTarget.classList.toggle('hidden')
  }
}
